import React from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';

/**
* An empty widget that is used to populate a layout column that contains no other widget content.
* Can also be left in the layout to create empty space if needed.
*/
export default class EmptyCell extends React.Component {
  static displayName = 'EmptyCell';
  render() {
    return (
      <div {...resolveTestId(this.props)} {...resolve(this.props, 'container')} />
    );
  }
}



// WEBPACK FOOTER //
// ./~/nucleus-widgets/lib/EmptyCell/EmptyCell.js